import React from 'react';
import { Box, Button, TextField } from '@mui/material';
import { ChromePicker } from 'react-color';
import { pickTextColorBasedOnBgColor } from 'js/library/utils/helpers';

export const ColorSelector = ({
  label,
  value,
  setValue,
  displayColorPicker,
  setDisplayColorPicker,
  required,
}) => {
  return (
    <Box width={'100%'} display={'flex'} flexDirection={'column'} rowGap={'8px'}>
      <Box display={'flex'} alignItems={'center'} width={'100%'} columnGap={'12px'}>
        <TextField
          fullWidth
          label={label}
          id="buttonColor"
          margin="normal"
          value={value}
          required={required}
          InputProps={{
            readOnly: true,
          }}
        />
        <Button
          sx={{
            backgroundColor: value || '',
            color: value ? pickTextColorBasedOnBgColor(value) : '#343434',
            width: '304px',
            height: 'inherit',
          }}
          variant="contained"
          onClick={() => setDisplayColorPicker((prevState) => !prevState)}
        >
          {displayColorPicker ? 'Salvar' : 'Selecione a cor'}
        </Button>
      </Box>
      {displayColorPicker && (
        <ChromePicker color={value} onChange={(event) => setValue(event.hex)} />
      )}
    </Box>
  );
};
